import { useContext, useEffect, useState } from "react"
import { userContext } from "../../UserContext"
import { useLocation, useNavigate } from 'react-router-dom'
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Container from 'react-bootstrap/Container';
import LogoutButton from "../Logout/Logout";

function NavBar () {
    const userInfo = useContext(userContext)
    const navigate = useNavigate()
    const location = useLocation()

    const [generateReportButtonClicked, clickGenerateReportButton] = useState(false)
    const [uploadDataButtonClicked, clickUploadDataButton] = useState(false)
    const [settingsButtonClicked, clickSettingsButton] = useState(false)

    useEffect( () => {
        if (generateReportButtonClicked) {
            if (location.pathname !== "/GenerateReport") {
                navigate("/GenerateReport")
            }
            clickGenerateReportButton(false)
        }
        if (settingsButtonClicked) {
            if (location.pathname !== "/Settings") {
                navigate("/Settings")
            }
            clickSettingsButton(false)
        }
        if (uploadDataButtonClicked) {
            if (!location.pathname !== "/UploadData") {
                navigate("/UploadData")
            }
            clickUploadDataButton(false)
        }
        }
    )
    
    const generateReportClickHandler = () => {
        clickGenerateReportButton(true)
    }
    const uploadDataClickHandler = () => {
        clickUploadDataButton(true)
    }
    const settingsClickHandler = () => {
        clickSettingsButton(true)
    }

    if(userInfo.userInfo.userRole == 1) {
        return(
            <section className="NavBar">
                <Navbar sticky="top" expand="lg" className="bg-body-tertiary">
                    <Container>
                        <Navbar.Brand>
                            Licence Generation
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav>
                                <Nav.Link onClick={generateReportClickHandler}>
                                    Generate Report
                                </Nav.Link>
                                <NavDropdown title="Dashboard" id="basic-navbar-nav">
                                    <NavDropdown.Item onClick={uploadDataClickHandler}>
                                        Upload Mobius Data
                                    </NavDropdown.Item>
                                    <NavDropdown.Item onClick={settingsClickHandler}>
                                        Settings
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </Nav>
                        </Navbar.Collapse>
                        <Navbar.Collapse className="justify-content-end">
                            <Nav>
                                <LogoutButton />
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </section>
        )
    } else if (userInfo.userInfo.userRole == 2) {
        return(
            <section className="NavBar">
                <Navbar sticky="top" expand="lg" className="bg-body-tertiary">
                    <Container>
                        <Navbar.Brand>
                            Licence Generation
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav>
                                <Nav.Link onClick={generateReportClickHandler}>
                                    Generate Report
                                </Nav.Link>
                                <NavDropdown title="Dashboard" id="basic-navbar-nav">
                                    <NavDropdown.Item onClick={settingsClickHandler}>
                                        Settings
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </Nav>
                        </Navbar.Collapse>
                        <Navbar.Collapse className="justify-content-end">
                            <Nav>
                                <LogoutButton />
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </section>
        )
    }
}

export default NavBar